import DeveloperTable from "@/app/app-shared/developer/table";

export default function DeveloperListingPage() {
  return (
    <div className="mt-4">
      <DeveloperTable />
    </div>
  );
}
